<div class="welcome-screen">
    <div>
        <!-- shiva style:  <img src="assets/images/logo.png"> -->
        <img src="assets/images/gnvert-style/logo_engie_white.png">
    </div>
    <div class="welcome-title" [translate]="'home.gnvert.welcome'"></div>
    <div class="welcome-text" [translate]="'home.gnvert.welcomeText'"></div>
    <div class="welcome-text" style="font-weight: bold;">{{VERSION}}</div>
</div>
